
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5.33333C2 3.08333 6.33333 2 10.3333 2C14.3333 2 18.6667 3.08333 18.6667 5.33333C18.6667 7.58333 14.3333 8.66667 10.3333 8.66667C6.33333 8.66667 2 7.58333 2 5.33333ZM10.3333 10.3333C7.16667 10.3333 3.91667 9.74998 2 8.33331V12C2 14.25 6.33333 15.3333 10.3333 15.3333C10.6803 15.3333 11.0297 15.3252 11.3786 15.3088C12.2778 12.797 14.679 11 17.5 11C17.8983 11 18.2882 11.0358 18.6667 11.1044V8.33331C16.75 9.74998 13.5 10.3333 10.3333 10.3333ZM10.3333 17C10.5618 17 10.7908 16.997 11.0197 16.9908C11.0066 17.1588 11 17.3286 11 17.5C11 19.1845 11.6408 20.7194 12.692 21.8742C11.9164 21.9583 11.1185 22 10.3333 22C6.33333 22 2 20.9167 2 18.6667V15C3.91667 16.4167 7.16667 17 10.3333 17ZM14.9177 17.4327C14.9177 15.9511 16.1188 14.75 17.6004 14.75C19.082 14.75 20.2831 15.9511 20.2831 17.4327C20.2831 18.1226 20.0237 18.7501 19.5959 19.2259C19.1037 19.7731 18.3926 20.1155 17.6004 20.1155C16.1188 20.1155 14.9177 18.9144 14.9177 17.4327ZM17.6004 13.25C15.2903 13.25 13.4177 15.1227 13.4177 17.4327C13.4177 19.7428 15.2903 21.6155 17.6004 21.6155C18.5508 21.6155 19.4276 21.2979 20.1297 20.7642L21.8958 22.5303L22.9565 21.4697L21.1435 19.6566C21.5485 19.0124 21.7831 18.2495 21.7831 17.4327C21.7831 15.1227 19.9105 13.25 17.6004 13.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowQuerydataSourceFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
